import React from 'react';
import { CircularProgress, CircularProgressProps } from '@mui/material';

type Props = CircularProgressProps;
const CustomCircularProgress = (props: Props) => {
  return <CircularProgress {...props} />;
};

export default CustomCircularProgress;
